import type { SxProps, Theme } from '@mui/material';

export const styles = {
    dock: (theme: Theme): SxProps<Theme> => ({
        position: 'fixed',
        bottom: 12,
        right: 12,
        width: 480,
        height: 540,
        zIndex: 1300,
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        boxShadow: theme.shadows[6],
        borderRadius: '12px',
    }),
    header: (theme: Theme) => ({
        height: 56,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        px: 2,
        borderBottom: `1px solid ${theme.palette.grey[100]}`,
        flexShrink: 0,
    }),
    title: { fontWeight: 600, fontSize: '14px' } as SxProps<Theme>,
    headerActions: { display: 'flex', alignItems: 'center', gap: 0.5 } as SxProps<Theme>,
    messages: {
        flex: 1,
        p: 2,
        overflow: 'auto',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        color: 'grey.500',
    } as SxProps<Theme>,
    composer: (theme: Theme) => ({
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        p: 1.5,
        borderTop: `1px solid ${theme.palette.grey[100]}`,
    }),
    minimizedBar: (theme: Theme): SxProps<Theme> => ({
        position: 'fixed',
        bottom: 12,
        right: 12,
        zIndex: 1300,
        bgcolor: theme.palette.blue.main,
        color: 'white',
        px: 2,
        py: 1,
        borderRadius: '999px',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        boxShadow: theme.shadows[4],
    }),
};
